import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiCore } from 'src/app/config/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { ToolsValidations } from 'src/app/core/tools/tools.validators';
import { IImagesUpload } from './interfaces';
import {
  catchError,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';

@Component({
  selector: 'app-configuration-casino-general',
  templateUrl: './configuration-casino-general.component.html',
  styleUrls: ['./configuration-casino-general.component.css'],
  providers: [MessageService],
})
export class ConfigurationCasinoGeneralComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<boolean>();
  public casinoForm!: FormGroup;
  configId: string = '';
  showConfirmSaveDialog: boolean = false;
  showProgressBar: boolean = false;
  showLoadSkeleton: boolean = false;
  countries_code_catalog: any[] = [];
  timezone_catalog: any[] = [];
  language_catalog: any[] = [];
  messaging_services_catalog: any[] = [];
  isButtonDisabled: boolean = true;
  public isPermissionConfiguracionOnly!: boolean;
  logo: any = null;
  image: any = null;
  metaImagenFile: any = null;
  metaImagen: any = null;
  formattedValue: string = '';
  favicon: any = null;
  faviconImage: any = null;
  imagesUpload!: IImagesUpload;
  imagesUploadArray: any[] = [];

  specialCharRegex: RegExp = /^[a-zA-Z0-9\s]*$/;
  validEmailRegex: RegExp =
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  onlyNumbersRegex: RegExp = /^[0-9]\d*$/;
  defaultValues = {
    casino_name: null,
    web_direction: null,
    logo: null,
    country_code: null,
    contact_phone: null,
    facebook: null,
    instagram: null,
    tiktok: null,
    timezone: null,
    lastestWinnersLimit: null,
    latestWinnersMultiplier: null,
    language: null,
    favicon: null,
    metaImagen: null,
    meta_tiulo: null,
    meta_descripcion: null,
  };
  lastestWinnersLimit: number = 0;
  currencyCode: string = '';
  currencyRegional: string = 'es-MX';
  currencySymbol: string = '';
  incomplete: boolean = false;
  isSaved: boolean = true;
  operatorId: string = '';
  country_code_catalog = [];

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
    private activRoute: ActivatedRoute,
    private session: SessionService,
    private auth: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    const incomplete = this.activRoute.snapshot.queryParamMap.get('incomplete');
    if (incomplete) {
      this.incomplete = true;
    }
    this.casinoForm = this.formBuilder.group({
      web_direction: [null],
      country_code: [null],
      contact_phone: [
        null,
        [
          Validators.minLength(8),
          Validators.maxLength(12),
          Validators.pattern(this.onlyNumbersRegex),
        ],
      ],
      facebook: [null, Validators.pattern(ToolsValidations.patternFacebook)],
      instagram: [null, Validators.pattern(ToolsValidations.patternInstagram)],
      tiktok: [null, Validators.pattern(ToolsValidations.patternTikTok)],
      timezone: [null, [Validators.required]],
      language: [null, [Validators.required]],
      casino_name: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(30),
          Validators.pattern(this.specialCharRegex),
        ],
      ],
      meta_tiulo: [null, [Validators.maxLength(70)]],
      meta_descripcion: [null, [Validators.maxLength(160)]],
      lastestWinnersLimit: [
        null,
        [Validators.min(0), Validators.maxLength(999999)],
      ],
      latestWinnersMultiplier: [
        null,
        [Validators.min(1), Validators.maxLength(5)],
      ],
    });

    if (!this.canEdit()) {
      this.casinoForm.disable();
      this.casinoForm.controls['web_direction'].enable();
    }
  }

  ngOnInit(): void {
    this.setIsPermissionConfiguracionOnly();
    this.getCountryCodes();
    this.getTimezoneCatalog();
    this.getLanguageCatalog();
    this.getOperatorConfigByOperatorId();
    // this.getMessagingServicesCatalog();
    //this.getOperatorConfig();
  }

  setIsPermissionConfiguracionOnly() {
    this.isPermissionConfiguracionOnly =
      this.auth.getPermission('Configuración') &&
      !this.auth.getPermission('Editar Casino General') &&
      !this.auth.getPermission('Editar Gestión de Créditos')
        ? true
        : false;
  }

  copyTextToClipBoard = () => {
    console.log(this.casinoForm.get('web_direction')?.value);
    navigator.clipboard
      .writeText(this.casinoForm.get('web_direction')?.value)
      .catch(() => {
        console.error('Unable to copy text');
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: 'Ocurrio un error al tratar de copiar enlace',
        });
      });
    this.messageService.add({
      key: 'bc',
      severity: 'success',
      summary: 'El enlace ha sido copiado al portapapeles',
      life: 1500,
      closable: false,
    });
  };

  getOperatorConfig = (operatorId?: string) => {
    this.showLoadSkeleton = true;
    this.api.list(`operator/operator-config`).subscribe((res) => {
      console.log(res);
      this.defaultValues.web_direction = res.data.guestUrl;
      this.defaultValues.casino_name = res.data.casinoName;
      this.defaultValues.logo = res.data.logoCasinoUrl;
      this.defaultValues.country_code = res.data.countryCodeId;
      this.defaultValues.contact_phone = res.data.contactPhone;

      this.defaultValues.facebook = res.data.facebook;
      this.defaultValues.instagram = res.data.instagram;
      this.defaultValues.tiktok = res.data.tiktok;

      this.defaultValues.meta_tiulo = res.data.metaTitulo;
      this.defaultValues.meta_descripcion = res.data.metaDescripcion;
      // this.defaultValues.metaImagen = res.data.metaImagen;

      this.defaultValues.timezone = res.data.timeZoneCasinoCatId;
      this.defaultValues.language = res.data.languageCasinoCatId;
      this.defaultValues.lastestWinnersLimit =
        res.data.maximumLimitLastestWinners;
      this.defaultValues.latestWinnersMultiplier =
        res.data.latestWinnersMultiplier;
      //set Values
      this.configId = res.data.id;
      this.casinoForm.get('web_direction')?.setValue(res.data.guestUrl);
      this.logo = res.data.logoCasinoUrl;
      this.favicon = res.data.faviconUrl;
      this.metaImagen = res.data.metaImagen;

      this.casinoForm.get('casino_name')?.setValue(res.data.casinoName);
      this.casinoForm.get('contact_email')?.setValue(res.data.contactEmail);
      this.casinoForm.get('country_code')?.setValue(res.data.countryCodeId);
      this.casinoForm.get('contact_phone')?.setValue(res.data.contactPhone);

      this.casinoForm
        .get('lastestWinnersLimit')
        ?.setValue(res.data.maximumLimitLastestWinners);

      this.casinoForm
        .get('latestWinnersMultiplier')
        ?.setValue(res.data.latestWinnersMultiplier);

      this.lastestWinnersLimit = res.data.maximumLimitLastestWinners;
      let messagingServices = res.data.mesaggingServices.map(
        (item: any) => item.messagingServiceId,
      );
      if (messagingServices.length) {
        this.casinoForm.get('messaging_services')?.setValue(messagingServices);
      }
      this.casinoForm.get('timezone')?.setValue(res.data.timeZoneCasinoCatId);
      this.casinoForm.get('language')?.setValue(res.data.languageCasinoCatId);

      this.casinoForm.get('casino_name')?.setValue(res.data.casinoName);
      this.casinoForm.get('country_code')?.setValue(res.data.countryCodeId);
      this.casinoForm.get('contact_phone')?.setValue(res.data.contactPhone);
      this.casinoForm.get('facebook')?.setValue(res.data.facebook);
      this.casinoForm.get('instagram')?.setValue(res.data.instagram);
      this.casinoForm.get('tiktok')?.setValue(res.data.tiktok);
      this.casinoForm.get('meta_tiulo')?.setValue(res.data.metaTitulo);
      this.casinoForm
        .get('meta_descripcion')
        ?.setValue(res.data.metaDescripcion);
      // let messagingServices = res.data.mesaggingServices.map((item: any) => item.messagingServiceId);
      // if(messagingServices.length) {
      //   this.casinoForm.get("messaging_services")?.setValue(messagingServices);
      // }
      this.casinoForm.get('timezone')?.setValue(res.data.timeZoneCasinoCatId);
      this.casinoForm.get('language')?.setValue(res.data.languageCasinoCatId);

      setTimeout(() => {
        this.showLoadSkeleton = false;
      }, 1000);
    });
  };

  getCountryCodes = () => {
    this.showLoadSkeleton = true;
    this.api.list('catalogs/country-codes-catalog').subscribe((res) => {
      this.countries_code_catalog = res.data;
      setTimeout(() => {
        this.showLoadSkeleton = false;
      }, 750);
    });
  };

  getTimezoneCatalog = () => {
    this.showLoadSkeleton = true;
    this.api.list('catalogs/timezone-catalog').subscribe((res) => {
      this.timezone_catalog = res.data;
      setTimeout(() => {
        this.showLoadSkeleton = false;
      }, 750);
    });
  };

  getLanguageCatalog = () => {
    this.showLoadSkeleton = true;
    this.api
      .list('catalogs/language-catalog?isActive=true')
      .subscribe((res) => {
        this.language_catalog = res.data;
        setTimeout(() => {
          this.showLoadSkeleton = false;
        }, 750);
      });
  };

  getMessagingServicesCatalog = () => {
    this.showLoadSkeleton = true;
    this.api
      .list('catalogs/messaging-services-catalog?isActive=true')
      .subscribe((res) => {
        this.messaging_services_catalog = res.data;
        setTimeout(() => {
          this.showLoadSkeleton = false;
        }, 750);
      });
  };

  loadLogo = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.png, .jpeg, .jpg';
    input.onchange = (e: any) => {
      console.log('LOAD LOGO?');
      console.log(e.target.files[0]);
      const file = e.target.files[0];
      this.image = file;
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: 'Formato de archivo no permitido',
        });
        return;
      }
      if (file.size > 1000000) {
        this.defaultValues.logo === null
          ? 'assets/images/no-photo-available.png'
          : this.defaultValues.logo;
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: 'La imagen excede el límite de peso',
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.logo = reader.result;
        this.messageService.add({
          severity: 'success',
          summary: 'Imagen cargada, no olvides guardar tus cambios',
        });
        this.isButtonDisabled = false;
      };
    };
    input.click();
  };

  loadMetaImagen = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.png, .jpg';
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg'
      ) {
        this.messageService.add({
          severity: 'error',
          summary: 'Formato de archivo no permitido',
        });
        return;
      }
      if (file.size > 1000000) {
        this.defaultValues.metaImagen === null
          ? 'assets/images/no-photo-available.png'
          : this.defaultValues.metaImagen;
        this.messageService.add({
          severity: 'error',
          summary: 'La imagen excede el límite de peso',
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = 300;
          canvas.height = 175;
          ctx?.drawImage(img, 0, 0, 300, 175);
          canvas.toBlob((blob) => {
            if (blob) {
              this.metaImagenFile = new File([blob], file.name, {
                type: file.type,
              });
              this.metaImagen = canvas.toDataURL(file.type);
              this.messageService.add({
                severity: 'success',
                summary: 'Imagen cargada, no olvides guardar tus cambios',
              });
              this.isButtonDisabled = false;
              this.changeDetectorRef.detectChanges();
            }
          }, file.type);
        };
      };
    };
    input.click();
  };

  closeDialog = () => {
    this.showConfirmSaveDialog = false;
    !this.incomplete ? document.body.classList.add('p-overflow-hidden') : '';
  };

  showDialog = () => {
    this.isButtonDisabled
      ? (this.showConfirmSaveDialog = false)
      : (this.showConfirmSaveDialog = true);
  };

  dataSaved = () => {
    this.messageEvent.emit(this.isSaved);
  };

  save = () => {
    this.showConfirmSaveDialog = true;

    const data = {
      casinoName: this.casinoForm.get('casino_name')?.value,
      contactEmail: this.casinoForm.get('contact_email')?.value,
      countryCodeId: this.casinoForm.get('contact_phone')?.value
        ? this.casinoForm.get('country_code')?.value
        : null,
      contactPhone: this.casinoForm.get('contact_phone')?.value,
      messagingServices: this.casinoForm.get('messaging_services')?.value,
      timeZoneCasinoCatId: this.casinoForm.get('timezone')?.value,
      lastestWinnersLimit: this.casinoForm.get('lastestWinnersLimit')?.value,
      latestWinnersMultiplier: this.casinoForm.get('latestWinnersMultiplier')
        ?.value,
      languageCasinoCatId: this.casinoForm.get('language')?.value,
      facebook: this.casinoForm.get('facebook')?.value,
      instagram: this.casinoForm.get('instagram')?.value,
      tiktok: this.casinoForm.get('tiktok')?.value,
      metaTitulo: this.casinoForm.get('meta_tiulo')?.value,
      metaDescripcion: this.casinoForm.get('meta_descripcion')?.value,
    };

    this.showProgressBar = true;

    this.api
      .updateDirect('operator/operator-config', data)
      .pipe(
        switchMap((response) => {
          if (response.statusCode !== 200) {
            throw new Error('Error al guardar los cambios');
          }

          const uploadTasks: Observable<void>[] = [];

          if (
            this.defaultValues.logo !== this.logo &&
            !this.logo.includes('https')
          ) {
            uploadTasks.push(
              this.saveImage({ file: this.image, id: this.configId }),
            );
          }

          if (
            this.defaultValues.favicon !== this.favicon &&
            !this.favicon.includes('https')
          ) {
            uploadTasks.push(
              this.saveFavicon({ file: this.faviconImage, id: this.configId }),
            );
          }

          if (
            this.defaultValues.metaImagen !== this.metaImagen &&
            !this.metaImagen.includes('https')
          ) {
            uploadTasks.push(
              this.saveMetaImagen({
                file: this.metaImagenFile,
                id: this.configId,
              }),
            );
          }

          return uploadTasks.length ? forkJoin(uploadTasks) : of(null);
        }),
        tap(() => {
          this.showProgressBar = false;
          this.showConfirmSaveDialog = false;

          setTimeout(() => {
            this.messageService.add({
              severity: 'success',
              summary: 'Cambios aplicados satisfactoriamente',
            });
          }, 300);

          this.getOperatorConfigByOperatorId();
          this.dataSaved();
          this.isButtonDisabled = true;
          this.saveMessagingService();
        }),
        catchError((err) => {
          console.error(err);
          this.showProgressBar = false;
          setTimeout(() => {
            this.messageService.add({
              severity: 'error',
              summary: 'Ha ocurrido un error al querer guardar los cambios',
            });
          }, 300);
          return of(null);
        }),
      )
      .subscribe();
  };

  saveImage = (data: any): Observable<void> => {
    this.showProgressBar = true;
    return this.api
      .uploadOperatorLogo('operator/upload-logo-casino-img', data)
      .pipe(map(() => {}));
  };

  saveMessagingService = () => {
    const bulkCreate: { operatorConfigId: string; messagingServiceId: any }[] =
      [];
    this.casinoForm.get('messaging_services')?.value.forEach((element: any) => {
      const data = {
        operatorConfigId: this.configId,
        messagingServiceId: element,
      };
      bulkCreate.push(data);
    });
    this.api
      .create(
        `${ApiCore.MESSAGING_SERVICES}?operatorConfigId=${this.configId}`,
        bulkCreate,
      )
      .subscribe(
        (res) => {
          if (res.statusCode === 201) {
            this.getOperatorConfigByOperatorId();
            //this.getOperatorConfig();
            this.dataSaved();
          }
        },
        (err) => {
          console.log(err);
        },
      );
  };

  changeSelect() {
    console.log(this.casinoForm.get('contact_phone')?.errors);
    console.log('isButtonDisabled', this.isButtonDisabled);
    console.log('this.casinoForm.valid', this.casinoForm.valid);
    console.log('this.casinoForm.valid', this.casinoForm.errors);
    const conditional =
      this.defaultValues.casino_name ===
        this.casinoForm.get('casino_name')?.value &&
      this.defaultValues.country_code ===
        this.casinoForm.get('country_code')?.value &&
      this.defaultValues.contact_phone ===
        this.casinoForm.get('contact_phone')?.value &&
      this.defaultValues.facebook === this.casinoForm.get('facebook')?.value &&
      this.defaultValues.instagram ===
        this.casinoForm.get('instagram')?.value &&
      this.defaultValues.tiktok === this.casinoForm.get('tiktok')?.value &&
      this.defaultValues.timezone === this.casinoForm.get('timezone')?.value &&
      this.defaultValues.language === this.casinoForm.get('language')?.value &&
      this.defaultValues.lastestWinnersLimit ===
        this.casinoForm.get('lastestWinnersLimit')?.value &&
      this.defaultValues.latestWinnersMultiplier ===
        this.casinoForm.get('latestWinnersMultiplier')?.value &&
      this.defaultValues.meta_tiulo ===
        this.casinoForm.get('meta_tiulo')?.value &&
      this.defaultValues.meta_descripcion ===
        this.casinoForm.get('meta_descripcion')?.value;
    console.log({ conditional });
    if (conditional) {
      this.isButtonDisabled = true;
    } else {
      if (this.casinoForm.valid) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
    }
  }

  validateNumber = (event: KeyboardEvent) => {
    const keyCode = event.keyCode;
    if (keyCode < 48 || keyCode > 57) {
      if (keyCode !== 8 && keyCode !== 9) {
        event.preventDefault();
      }
    }
  };

  public sliceNumber() {
    this.casinoForm
      .get('contact_phone')
      ?.setValue(this.casinoForm.get('contact_phone')?.value.slice(0, 12));
  }

  getOperatorConfigByOperatorId = () => {
    const token: any = this.session.getItem('token');
    this.api.getOperatorId(token).subscribe({
      next: (res) => {
        this.operatorId = res.data.operatorId;
        this.currencySymbol = res.data.currencySymbol;
        this.currencyCode = res.data.currencyCode;
        this.currencyRegional = res.data.currencyRegional;
        this.getOperatorConfig(/*res.data.operatorId*/);
      },
    });
  };

  canEdit() {
    return this.auth.getPermission('Editar Casino General');
  }
  blockExtraDigits(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End',
    ];
    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (event.key === '.' && !input.value.includes('.')) {
      return;
    }

    if (/^\d$/.test(event.key)) {
      const currentDigits = input.value.replace(/\D/g, '');

      const selectionStart = input.selectionStart ?? 0;
      const selectionEnd = input.selectionEnd ?? 0;
      const selectedText = input.value.substring(selectionStart, selectionEnd);
      const selectedDigits = selectedText.replace(/\D/g, '');

      const effectiveDigits = currentDigits.length - selectedDigits.length + 1;

      if (effectiveDigits > 6) {
        event.preventDefault();
      }
    }
  }

  loadFavicon = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.png, .jpeg, .jpg, .ico, .svg';
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      console.log(file.type);
      if (
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/x-icon' &&
        file.type !== 'image/vnd.microsoft.icon' &&
        file.type !== 'image/svg+xml'
      ) {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'Formato de archivo no permitido',
        });
        return;
      }
      if (file.size > 1048576) {
        this.defaultValues.logo === null
          ? 'assets/images/no-photo-available.png'
          : this.defaultValues.logo;
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'La imagen excede el límite de peso',
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = 48;
          canvas.height = 48;
          ctx?.drawImage(img, 0, 0, 48, 48);
          canvas.toBlob((blob) => {
            if (blob) {
              this.faviconImage = new File([blob], file.name, {
                type: file.type,
              });
              this.favicon = canvas.toDataURL(file.type);
              this.messageService.add({
                severity: 'success',
                summary: 'Imagen cargada, no olvides guardar tus cambios',
              });
              this.isButtonDisabled = false;
              this.changeDetectorRef.detectChanges();
            }
          }, file.type);
        };
      };
    };
    input.click();
  };

  saveFavicon = (data: any): Observable<void> => {
    this.showProgressBar = true;
    return this.api
      .uploadOperatorLogo('operator/upload-favicon-casino-img', data)
      .pipe(map(() => {}));
  };

  saveMetaImagen = (data: any): Observable<void> => {
    this.showProgressBar = true;
    return this.api
      .uploadOperatorLogo('operator/upload-metaimagen-casino-img', data)
      .pipe(map(() => {}));
  };

  onInputChange(field: string): void {
    const control = this.casinoForm.get(field);

    if (field === 'meta_tiulo') {
      if (control && control.value.length > 70) {
        control.setValue(control.value.substring(0, 70));
      }
      return;
    }

    if (field === 'meta_descripcion') {
      if (control && control.value.length > 160) {
        control.setValue(control.value.substring(0, 160));
      }
      return;
    }
  }
}
